import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class CafeMenuService {
  OBPortalSvcURL = '';

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient
  ) {}

  public getCafeMenus(mttName: string | undefined): Observable<any> {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    const CafeMenusInfo: JSON = <JSON>(<unknown>{
      mttName: mttName,
    });
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.post<any>(
      this.OBPortalSvcURL + 'GetCafeMenus',
      JSON.stringify(CafeMenusInfo),
      { headers: headers }
    );
  }
}
